// Simple helpers to detect when the app is running inside the hybrid mobile shell.
// The mobile shell can inject `window.__IS_MOBILE_APP__ = true` if needed.

import { Capacitor } from '@capacitor/core';

export function isMobileContainer() {
  if (typeof window === 'undefined') return false;
  // 1) Explicit flag injected by the native shell (recommended)
  if (window.__IS_MOBILE_APP__) return true;

  // 2) Capacitor native runtime (@capacitor/core — reliable in hybrid builds)
  try {
    if (Capacitor.isNativePlatform()) return true;
  } catch {
    // ignore
  }

  // 3) Capacitor bridge on window (fallback for early boot)
  if (window.Capacitor) {
    try {
      // Capacitor may exist on web builds too; guard with platform checks.
      const platform = typeof window.Capacitor.getPlatform === 'function'
        ? window.Capacitor.getPlatform()
        : null;
      if (platform === 'web') return false;
      if (typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform()) {
        return true;
      }
    } catch {
      // ignore
    }
  }

  // 4) Manual override for testing in browser: add `?app=mobile`
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('app') === 'mobile') return true;
  } catch {
    // ignore
  }

  // Do NOT use viewport-size as a signal — that would affect the normal web UI.
  return false;
}

export function isNativePlatform() {
  if (typeof window === 'undefined') return false;
  try {
    return Capacitor.isNativePlatform() === true;
  } catch {
    return window.Capacitor?.isNativePlatform?.() === true;
  }
}

